import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/ai/research-assistant/page.tsx");
